import {Component, inject, input, PLATFORM_ID} from '@angular/core';
import {ShowEventDate} from '../../../../common/pipe/showEventDate.pipe';
import {ShowFreeDate} from '../../../../common/pipe/showFreeDate.pipe';
import {NgForOf, NgIf} from '@angular/common';
import {SubscriptionContextV2Service} from '../../../../services/subscription-v2-context.service';
import {ShowPricePipe} from '../../../../common/pipe/showPrice.pipe';
import {ageThreads} from '../../../../common/sessions';
import {SessionDTO} from '@minutespourtoi/api-models/dist/models';

@Component({
  selector: 'app-session-content',
  imports: [
    ShowEventDate,
    ShowFreeDate,
    NgIf,
    NgForOf,
    ShowPricePipe
  ],
  templateUrl: './session-content.component.html'
})
export class SessionContentComponent {

  protected readonly ageThreads = ageThreads;
  session = input<SessionDTO>(null)
  subscriptionContextV2Service = inject(SubscriptionContextV2Service)

  platformId = inject(PLATFORM_ID);



}
